/* LFDY Landing – Video-Hero + Stores
   Spielt nur das sichtbare Video ab (Desktop- oder Mobile-Version), damit nie beide laden.
   Pause/Play-Button (Barrierefreiheit), Ton-Schalter optional, respektiert „Bewegung reduzieren“. */
(() => {
  if (window.__lfdyLanding) return;
  window.__lfdyLanding = true;
  function visible(el) { return el && el.offsetParent !== null; }

  function initHero(root) {
    if (!root || root.dataset.lfdyInit) return;
    root.dataset.lfdyInit = '1';
    const videos = [...root.querySelectorAll('video')];
    // Poster-Bild bleibt sichtbar, bis das Video wirklich Bilder abspielt.
    // Erst wenn die Zeit tatsächlich weiterläuft, wird das Video eingeblendet. Wird es gestoppt, bevor
    // ein Bild lief (z. B. Energiesparmodus blockiert Autoplay), bleibt das Poster stehen.
    videos.forEach((v) => {
      const check = () => { if (!v.paused && v.currentTime > 0.05) v.classList.add('is-playing'); };
      v.addEventListener('timeupdate', check);
      v.addEventListener('pause', () => { if (v.currentTime < 0.25) v.classList.remove('is-playing'); });
      check();
    });
    const playBtn = root.querySelector('[data-lfdy-play]');
    const soundBtn = root.querySelector('[data-lfdy-sound]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = null;
    let userPaused = reduce;   // „Bewegung reduzieren“: startet pausiert
    let inView = true;

    const syncPlay = () => {
      if (!playBtn) return;
      const paused = !active || active.paused;
      playBtn.setAttribute('aria-pressed', String(paused));
      playBtn.setAttribute('aria-label', paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause);
    };
    const run = () => {
      if (!active) return syncPlay();
      if (!userPaused && inView) {
        const pr = active.play();
        if (pr && pr.catch) pr.catch(() => { syncPlay(); });   // Autoplay blockiert → Poster bleibt, Button zeigt „Play“
      } else active.pause();
    };

    const pick = () => {
      const next = videos.find(visible) || null;
      if (next === active) return;
      if (active) active.pause();
      active = next;
      if (!active) return syncPlay();
      active.muted = !soundBtn || soundBtn.getAttribute('aria-pressed') !== 'true';
      ['play', 'pause'].forEach((ev) => active.addEventListener(ev, syncPlay));
      run();
    };

    // Vollbild: Höhe = Bildschirm minus alles, was über dem Video steht (Header, Ankündigungsleiste)
    const media = root.querySelector('.lfdy-l__hero-media');
    const setTop = () => {
      if (!media) return;
      const top = Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY));
      media.style.setProperty('--hero-top', top + 'px');
    };
    setTop();
    window.addEventListener('load', setTop);
    window.addEventListener('resize', () => requestAnimationFrame(setTop), { passive: true });

    pick();
    syncPlay();
    window.addEventListener('resize', () => requestAnimationFrame(pick), { passive: true });

    // Pause/Play (Barrierefreiheit: bewegte Inhalte müssen anhaltbar sein)
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (!active) return;
        userPaused = !active.paused;
        run();
      });
    }

    // Ton an/aus
    if (soundBtn) {
      soundBtn.addEventListener('click', () => {
        if (!active) return;
        const on = soundBtn.getAttribute('aria-pressed') !== 'true';
        videos.forEach((v) => { v.muted = !on; });
        soundBtn.setAttribute('aria-pressed', String(on));
        soundBtn.setAttribute('aria-label', on ? soundBtn.dataset.labelOff : soundBtn.dataset.labelOn);
        if (on) { userPaused = false; run(); }
      });
    }

    // Außerhalb des Sichtfelds pausieren (spart Akku/Daten), danach weiter – außer der Nutzer hat pausiert
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => { inView = e.isIntersecting; run(); });
      }, { threshold: 0.15 }).observe(root);
    }
  }

  // Stores: Klick auf Stadt wechselt Foto + Infos
  function initStores(root) {
    if (!root || root.dataset.lfdyInit) return;
    root.dataset.lfdyInit = '1';
    const btns = [...root.querySelectorAll('[data-store]')];
    const panels = [...root.querySelectorAll('[data-store-panel]')];
    const show = (i) => {
      btns.forEach((b) => { const on = b.dataset.store === i; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
      panels.forEach((p) => { const on = p.dataset.storePanel === i; p.setAttribute('aria-hidden', String(!on)); p.classList.toggle('is-active', on); });
    };
    btns.forEach((b) => {
      b.addEventListener('click', () => {
        show(b.dataset.store);
        // Mobile: Foto steht über der Liste – ins Bild holen, falls nicht sichtbar
        const p = root.querySelector('[data-store-panel].is-active');
        if (p && p.getBoundingClientRect().top < 0) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      // Desktop: Hover zeigt das Foto schon an
      b.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) show(b.dataset.store); });
    });
    // Theme-Editor: Block auswählen = Store anzeigen
    root.addEventListener('shopify:block:select', (e) => {
      const b = e.target.querySelector('[data-store]');
      if (b) show(b.dataset.store);
    });
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-lfdy-hero]').forEach(initHero);
    scope.querySelectorAll('[data-lfdy-stores]').forEach(initStores);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
